import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {AnswerCompleteness} from '../../rfi-individual-results.calc';
import {RfiAnswerCompletenessComponent} from '../../parts/rfi-answer-completeness/rfi-answer-completeness.component';
import {RfiAssessmentGroupComponent} from '../../parts/rfi-assessment-group/rfi-assessment-group.component';
import {AssessmentGroup} from '../../rfi-individual-results-modal.types';

@Component({
  selector: 'app-rfi-culture-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, RfiAnswerCompletenessComponent, RfiAssessmentGroupComponent],
  host: {class: 'flex flex-col gap-4'},
  templateUrl: './rfi-culture-section.component.html',
})
export class RfiCultureSectionComponent {
  readonly completeness = input.required<AnswerCompleteness>();
  readonly groups = input.required<AssessmentGroup[]>();
}
